export type ButtonStyle = 'rounded' | 'pill' | 'square'

export interface RadiusTokens {
  card: string
  chip: string
  sheet: string
}

const RADIUS_TOKENS: Record<ButtonStyle, RadiusTokens> = {
  rounded: { card: '1rem', chip: '9999px', sheet: '1rem' },
  pill: { card: '1.5rem', chip: '9999px', sheet: '1.5rem' },
  square: { card: '0.375rem', chip: '0.375rem', sheet: '0.375rem' },
}

export function getRadiusTokens(buttonStyle: string): RadiusTokens {
  return RADIUS_TOKENS[buttonStyle as ButtonStyle] ?? RADIUS_TOKENS.rounded
}
